/**
 * 前后端交互数据接口API配置
 */

import Url from 'c-url';

module.exports = {
    /**
     * Java域名配置
     */
    originMap: {
        stage: 'http://uppayment-test.upliveapps.com',
        pro: 'https://uppay.upliveapp.com',
        dev: 'http://uppayment-test.upliveapps.com'
    },

    /**
     * 根据环境获取接口域名
     * @name getOrigin
     */
    getOrigin: function () {
        // 当前开发环境
        var env = Url.query('env');
        var host;

        if (!env || env == 'null') {
            env = 'pro';
        }

        host = this.originMap[env] || this.originMap['pro'];

        return host;
    },



    /**
     * 提交发票信息
     * @param 
     */
    pushInvoice: function () {
        return this.getOrigin() + '/push/invoice';
    },
}



// WEBPACK FOOTER //
// ./js/global/api.js